//账单

export default [

    {   //计费项目
        path: "newbigaccount/accountproject",
        name: "accountproject",
        component: () => import(/* webpackChunkName: "newbigaccount" */ "@/views/newbigaccount/accountproject/index"),
    },
    {   //费用类型
        path: "newbigaccount/billtype/list",
        name: "bigaccountBilltype",
        component: () => import(/* webpackChunkName: "newbigaccount" */ "@/views/newbigaccount/billtype/index"),
    },
    {   //费用类型
        path: "newbigaccount/billtype/detail/:type",
        name: "bigaccountBilltypeDetail",
        component: () => import(/* webpackChunkName: "newbigaccount" */ "@/views/newbigaccount/billtype/update"),
    },
    {   //价格维护
        path: "newbigaccount/pricemaintain",
        name: "bigaccountPricemaintain",
        component: () => import(/* webpackChunkName: "newbigaccount" */ "@/views/newbigaccount/pricemaintain/index"),
    },
    {   //价格维护
        path: "newbigaccount/pricemaintain/detail/:type",
        name: "bigaccountPricemaintainDetail",
        component: () => import(/* webpackChunkName: "newbigaccount" */ "@/views/newbigaccount/pricemaintain/update"),
    },

    // 费用类型分配组织
    {
        path: "newbigaccount/billorg",
        name: "bigaccountBillorg",
        component: () => import(/* webpackChunkName: "newbigaccount" */ "@/views/newbigaccount/billorg/index"),
    },
    // 费用类型分配项目
    {
        path: "newbigaccount/billproject",
        name: "bigaccountBillproject",
        component: () => import(/* webpackChunkName: "newbigaccount" */ "@/views/newbigaccount/billproject/index"),
    },
    // 结算明细
    {
        path: "newbigaccount/billdetail",
        name: "bigaccountBilldetail",
        component: () => import(/* webpackChunkName: "newbigaccount" */ "@/views/newbigaccount/billdetail/index"),
    },
    // 账期
    {
        path: "newbigaccount/paymentday",
        name: "bigaccountPaymentday",
        component: () => import(/* webpackChunkName: "newbigaccount" */ "@/views/newbigaccount/paymentday/index"),
    },
    {   //账期编辑
        path: "newbigaccount/paymentday/detail/:type",
        name: "bigaccountPaymentdayDetail",
        component: () => import(/* webpackChunkName: "newbigaccount" */ "@/views/newbigaccount/paymentday/update"),
    },
    // 费用名称
    {
        path: "newbigaccount/billname",
        name: "bigaccountBillname",
        component: () => import(/* webpackChunkName: "newbigaccount" */ "@/views/newbigaccount/billname/index"),
    },
    {
        path: "newbigaccount/billname/detail/:type",
        name: "bigaccountbillnameDetail",
        component: () => import(/* webpackChunkName: "newbigaccount" */ "@/views/newbigaccount/billname/update"),
    },
    // 账单汇总
    {
        path: "newbigaccount/storageorder/total",
        name: "bigaccountStorageorderTotal",
        component: () => import(/* webpackChunkName: "newbigaccount" */ "@/views/newbigaccount/storageorder/total/index"),
    },

    // 账单明细
    {
        path: "newbigaccount/storageorder/billdetail",
        name: "bigaccountStorageBilldetail",
        component: () => import(/* webpackChunkName: "newbigaccount" */ "@/views/newbigaccount/storageorder/detail/index"),
    },

    // 客户账单明细
    {
        path: "newbigaccount/storageorderclient/billdetail",
        name: "bigaccountStorageBilldetailClient",
        component: () => import(/* webpackChunkName: "newbigaccount" */ "@/views/newbigaccount/storageorderclient/index"),
    },

    // 账单生成异常
    {
        path: "newbigaccount/storageorder/billerror",
        name: "bigaccountStorageBillerror",
        component: () => import(/* webpackChunkName: "newbigaccount" */ "@/views/newbigaccount/storageorder/error/index"),
    },

    // 计费黑名单和计费重处理
    {
        path: "newbigaccount/bill/billblack",
        name: "newBigbillBlack",
        component: () => import(/* webpackChunkName: "newbigaccount" */ "@/views/newbigaccount/bill/billblack"),
    },
    {
        path: "newbigaccount/bill/rehandle",
        name: "newBigbillRehandle",
        component: () => import(/* webpackChunkName: "newbigaccount" */ "@/views/newbigaccount/bill/rehandle"),
    },
]


